import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Compare from "./pages/Compare";
import Coas from "./pages/Coas";
import Journal from "./pages/Journal";
import JournalArticle from "./pages/JournalArticle";
import Docs from "./pages/Docs";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import CartPage from "./pages/CartPage";
import Checkout from "./pages/Checkout";
import OrderPage from "./pages/OrderPage";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import Calculator from "./pages/Calculator";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "./pages/auth/AuthPages";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminProducts from "./admin/AdminProducts";
import AdminInventory from "./admin/AdminInventory";
import AdminOrders from "./admin/AdminOrders";
import AdminPayments from "./admin/AdminPayments";
import AdminCrypto from "./admin/AdminCrypto";
import AdminCustomers from "./admin/AdminCustomers";
import AdminJournal from "./admin/AdminJournal";
import AdminAnalytics from "./admin/AdminAnalytics";
import AdminSettings, { AdminSocial } from "./admin/AdminSettings";
import AdminPaymentSettings from "./admin/AdminPaymentSettings";
import AdminAdmins from "./admin/AdminAdmins";
import { AdminSuppliers, AdminCoas, AdminFaqs, AdminDocs, AdminDiscounts, AdminShipping } from "./admin/AdminGeneric";

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth callback: session_id arrives in the URL fragment — handle before any route.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/coas" element={<Coas />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalArticle />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/docs/:slug" element={<Docs />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/basket" element={<CartPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:orderId" element={<OrderPage />} />
        <Route path="/account" element={<Account />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
      </Route>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="inventory" element={<AdminInventory />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="crypto" element={<AdminCrypto />} />
        <Route path="customers" element={<AdminCustomers />} />
        <Route path="suppliers" element={<AdminSuppliers />} />
        <Route path="coas" element={<AdminCoas />} />
        <Route path="journal" element={<AdminJournal />} />
        <Route path="docs" element={<AdminDocs />} />
        <Route path="faqs" element={<AdminFaqs />} />
        <Route path="discounts" element={<AdminDiscounts />} />
        <Route path="shipping" element={<AdminShipping />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="payment-settings" element={<AdminPaymentSettings />} />
        <Route path="social" element={<AdminSocial />} />
        <Route path="admins" element={<AdminAdmins />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <CartProvider>
              <AppRouter />
            </CartProvider>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
